import { Identity } from '../../../core/type'

export enum OnlinePaymentStatus {
  Pending = 'Pending',
  Completed = 'Completed',
  Cancelled = 'Cancelled',
  Failed = 'Failed',
}

export interface Checkout {
  id: number
  createdAt: string
  updatedAt: string
  userId?: number
  guestId?: string
  customerId?: number
  shoppingCartId: number
  phone?: string
  email?: string
  freight?: number
  tax?: number
  specialInstructions?: string
  shippingMethod?: string
  payable?: number
}

export interface OnlinePayment extends Identity {
  createdAt: string
  updatedAt: string
  userId?: number
  guestId?: string
  checkoutId: number
  checkout?: Checkout
  status: OnlinePaymentStatus
  provider: string
  email?: string
  payable?: number
  reference?: string
  clientReturnURL?: string
  clientCancelURL?: string
  errorMessage?: string
}

export interface OnlinePaymentFindRequest {
  status?: OnlinePaymentStatus | number
}

